export const FETCH_CANDIDATE_REQUEST     = "FETCH_CANDIDATE_REQUEST";
export const FETCH_CANDIDATE_SUCCESSFUL  = "FETCH_CANDIDATE_SUCCESSFUL";
export const FETCH_CANDIDATE_FAILURE     = "FETCH_CANDIDATE_FAILURE";

export const UPDATE_CANDIDATE_REQUEST     = "UPDATE_CANDIDATE_REQUEST";
export const UPDATE_CANDIDATE_SUCCESSFUL  = "UPDATE_CANDIDATE_SUCCESSFUL";
export const UPDATE_CANDIDATE_FAILURE     = "UPDATE_CANDIDATE_FAILURE";